import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setInvoicePositionQuantity } from "../../../../store/slices/invoiceV2Slice";
import PositionRowInTable from "./PositionRowInTable";
import "./ExpandablePositionsTable.scss";
import "./PositionRowInTable.scss";

const ExpandablePositionsTable = React.memo(
    ({
        positions,
        isReadonly = false,
    }) => {
        const { t } = useTranslation();
        const dispatch = useDispatch();

        const handleQuantityChange = useCallback(
            (position, newValue) => {
                const numericValue =
                    newValue === "" ? 0 : parseFloat(newValue) || 0;
                dispatch(
                    setInvoicePositionQuantity({
                        positionId: position.id,
                        quantity: numericValue,
                        position: position,
                    }),
                );
            },
            [dispatch],
        );

        return (
            <div className="positions-table-outer">
                <div className="positions-table-inner">
                    <div className="positions-table-header">
                        <div className="col-sticky-1">{t("invoice.type")}</div>
                        <div className="col-sticky-2">
                            {t("hierarchical-positions.position")}
                        </div>
                        <div className="col-sticky-3 positions-table-col-description">
                            {t("hierarchical-positions.short-description")}
                        </div>
                        <div>{t("hierarchical-positions.lv-items")}</div>
                        <div>{t("hierarchical-positions.invoice-items")}</div>
                        <div>{t("hierarchical-positions.unit-lv")}</div>
                        <div>{t("hierarchical-positions.unit-price")}</div>
                        <div>{t("hierarchical-positions.total-price-lv")}</div>
                        <div>{t("hierarchical-positions.inv-amount")}</div>
                        <div>{t("hierarchical-positions.inv-calc")}</div>
                        <div>{t("hierarchical-positions.warning")}</div>
                        <div className="positions-table-col-comments">
                            {t("hierarchical-positions.comments")}
                        </div>
                    </div>

                    {positions.map((position, index) => (
                        <PositionRowInTable
                            key={position.id}
                            position={position}
                            index={index}
                            handleQuantityChange={handleQuantityChange}
                            isReadonly={isReadonly}
                            t={t}
                        />
                    ))}
                </div>
            </div>
        );
    },
);

export default ExpandablePositionsTable;
